import module from 'contabilidad/polizasexternas/module'
import template from './template.html'
export class contabilidadPolizasexternasAlgodonerosIngresosComponent {
  cuentas = []
  procesando = false
  descargando = false
  exito = false
  error = null

  constructor($location, CuentasBancarias, PolizasExternasAlgodonerosIngresos) {
    this.$location = $location
    this.CuentasBancarias = CuentasBancarias
    this.polizasExternasAlgodonerosIngresos = PolizasExternasAlgodonerosIngresos
  }

  $onInit() {
    this.promise = this.polizasExternasAlgodonerosIngresos.empresaCuentas(this.busqueda.empresaId)
      .then((resolve) => {
        this.cuentas = resolve.data.cuentas
      })
  }

  $onChanges(changes) {
    this.busqueda = {
      fechaInicial: changes.busqueda.currentValue.fechaInicial || new Date(),
      fechaFinal: changes.busqueda.currentValue.fechaFinal || new Date(),
      empresaId: changes.busqueda.currentValue.empresaId || 77,
      cuentaId: changes.busqueda.currentValue.cuentaId || undefined
    }

    if (this.busqueda.cuentaId) {
      this.buscar()
    }

    this.busqueda.empresaId = 77 ////Empresa de guasave
  }

  buscar() {
    if (this.busqueda.empresaId && this.busqueda.cuentaId) {

      this.await = this.polizasExternasAlgodonerosIngresos.empresaCuenta(this.busqueda.empresaId, this.busqueda.cuentaId)
        .then((resolve) => {
          this.busqueda.cuentaKardexId = resolve.data.id_cuenta_kardex
          this.$location.search({
            fechaInicial: this.busqueda.fechaInicial.toYMD(),
            fechaFinal: this.busqueda.fechaFinal.toYMD(),
            empresaId: this.busqueda.empresaId,
            cuentaId: this.busqueda.cuentaId,
            cuentaKardexId: this.busqueda.cuentaKardexId
          })
        })
    }
  }

  descargar() {
    if (this.busqueda.empresaId && this.busqueda.cuentaId) {
      if (this.procesando && this.descargando) return

      this.exito = false
      this.procesando = true
      this.descargando = true
      this.error = null
      console.log('exito', this.exito)
      this.polizasExternasAlgodonerosIngresos.descargarExcel(this.busqueda)
        .then((response) => {
          this.exito = true
          response.data.save()
        })
        .catch((error) => { this.error = error.data })
        .finally(() => { this.procesando = false })
    }
  }
}

module.component('contabilidadPolizasexternasAlgodonerosIngresos', {
  controller: contabilidadPolizasexternasAlgodonerosIngresosComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/ingresos/component.js